export default __webpack_public_path__ + "static/media/QuickBooks Logo_Horz.3a04d204.png";